<template>
	<section>
		<div class="content-header">
            <div class="content-header-left mb-2">
                <div class="breadcrumbs-top">
                    <h2 class="content-header-title mb-0">{{ table.title }} </h2>
                    <div class="breadcrumb-wrapper">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link to="/">
                                    <i class="feather icon-home"></i>
                                </router-link>
                            </li>
                            <li class="breadcrumb-item">
                                <a>{{ table.breadcumb }}</a>
                            </li>
                            <li class="breadcrumb-item active">{{ table.title }}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section id="basic-datatable">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-content">
                                <div class="card-body card-dashboard">
                                    <div class="row align-items-center justify-content-between">
                                        <div class="col mb-1">
                                            <div class="btn-responsive">
                                                <button type="submit" class="btn btn-primary waves-effect waves-light" data-toggle="modal" data-target="#Modal_FilterKontrak" style="margin-left: 3px;">
                                                    <i class="fa fa-filter fa-l" aria-hidden="true"></i> Filter Laporan
                                                </button>
                                                &emsp;
                                                <button v-can="'laporan/dokumen_amd_proses/generate'" @click="cetak()" class="btn btn-outline-primary waves-effect waves-light" 
                                                
                                                    v-if="table.dataTable.lists.data" 
                                                    :disabled="table.dataTable.lists.data.length == 0">
                                                    <i class="fa fa-file-excel-o fa-l" aria-hidden="true"></i> Cetak Excel
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="table-responsive tableFixHead">
                                        <table class="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th @click="sortBy('kontrak_nomor')">Nomor Kontrak
                                                        <i class="fa sort" :class="currentSort == 'kontrak_nomor' ? (currentSortDir == 'asc' ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
                                                    </th>
                                                    <th @click="sortBy('kontrak_judul')">Nama Kontrak 
                                                        <i class="fa sort" :class="currentSort == 'kontrak_judul' ? (currentSortDir == 'asc' ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
                                                    </th>
                                                    <th @click="sortBy('amandemen_date')">Tanggal 
                                                        <i class="fa sort" :class="currentSort == 'amandemen_date' ? (currentSortDir == 'asc' ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
                                                    </th>
                                                    <th @click="sortBy('amandemen_name')">Nama Dokumen 
                                                        <i class="fa sort" :class="currentSort == 'amandemen_name' ? (currentSortDir == 'asc' ? 'fa-sort-down' : 'fa-sort-up') : 'fa-sort'"></i>
                                                    </th>
                                                    <th>Link</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="table.dataTable.lists.data && table.dataTable.lists.data.length > 0">
                                                <tr v-for="(data, key) in table.dataTable.lists.data" :key="key">
                                                    <td>{{ ((table.dataTable.lists.current_page - 1) * table.dataTable.lists.per_page + key + 1) }}</td>
                                                    <td>{{ data.kontrak_nomor || '-' }}</td>
                                                    <td><strong>{{ data.kontrak_judul || '-' }}</strong></td>
                                                    <td>{{ data.amandemen_date ? moment(data.amandemen_date).format('DD-MM-YYYY') : '-' }}</td>
                                                    <td>{{ data.amandemen_name || '-' }}</td>
                                                    <td class="file-detail">
                                                        <span v-if="!data.documents || !data.documents.length">-</span>
                                                        <template v-else>
                                                            <a @click="
                                                                amandemen_detail = data;
                                                                openFileAmendment(); 
                                                            " href="javascript:;" class="text-primary">[Lihat Detail]</a>
                                                        </template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody v-else>
                                                <tr>
                                                    <td colspan="6" class="text-center">Tidak ada data.</td>
                                                </tr>
                                            </tbody>           
                                        </table>                                                                        
                                    </div>
                                    <PaginateList :data="table.dataTable.lists" v-if="table.dataTable.lists.total != 0"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="modal fade text-left show" id="Modal_FilterKontrak" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header modal-primary white">
                        <h5 class="modal-title" id="myModalLabel160">Filter Dokumen AMD Proses</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row mb-1" v-for="(f, idx) in filter" :key="idx">
                            <div class="col-8 col-sm-10">
                                <div class="row">
                                    <div class="col-12 col-sm-6">
                                        <div class="form-group">
                                            <label for="filter_by">Filter Berdasarkan</label>
                                            <select class="form-control" v-model="f.by" :disabled="f.by != '-'">
                                                <option v-for="(data, index) in filterOption" :key="index" :value="data.by">{{data.name}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-6" v-if="f.by == 'date_start'">
                                        <div class="form-group">
                                            <label for="filter_by">Tanggal Awal</label>
                                            <div class="position-relative has-icon-left">                                                
                                                <date-picker
                                                    v-model="filterby.date_start"
                                                    format="DD/MM/YYYY"
                                                    type="date"
                                                    value-type="YYYY-MM-DD"
                                                    placeholder="Tanggal awal dokumen (dd/mm/yyyy)"  
                                                    style="width: 100%"
                                                ></date-picker>
                                            </div>                                            
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-6" v-else-if="f.by == 'date_end'">
                                        <div class="form-group">
                                            <label for="filter_by">Tanggal Akhir</label>
                                            <div class="position-relative has-icon-left">                                                
                                                <date-picker
                                                    v-model="filterby.date_end"
                                                    format="DD/MM/YYYY"
                                                    type="date"
                                                    value-type="YYYY-MM-DD"
                                                    placeholder="Tanggal akhir dokumen (dd/mm/yyyy)"   
                                                    style="width: 100%"
                                                ></date-picker>
                                            </div>                                            
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-6" v-else-if="f.by == 'search'">
                                        <div class="form-group">
                                            <label for="filter_by">Pencarian</label>                                                                                        
                                            <input type="text" class="form-control" v-model="filterby.search" placeholder="Cari berdasarkan nama kontrak, nomor kontrak, atau nama dokumen...">                                                                             
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-6" v-else>
                                        <div class="form-group">
                                            <label for="filter_by">-</label>
                                            <input type="text" class="form-control" disabled>                               
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4 col-sm-2 d-flex align-items-center">
                                <button class="btn-transparent" @click="addFilter()" v-if="idx == filter.length - 1">
                                    <svg class="img-fluid mr-2" width="20" height="21" viewBox="0 0 20 21">
                                        <path fill="#17536A" fill-rule="nonzero" d="M10 .134c-5.523 0-10 4.476-10 10 0 5.523 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zm0 18.75a8.75 8.75 0 1 1 0-17.5 8.75 8.75 0 0 1 0 17.5zm3.75-9.375h-3.125V6.384a.625.625 0 0 0-1.25 0v3.125H6.25a.625.625 0 0 0 0 1.25h3.125v3.125a.625.625 0 0 0 1.25 0v-3.125h3.125a.625.625 0 0 0 0-1.25z"></path>
                                    </svg>
                                </button>
                                <button class="btn-transparent" @click="deleteFilter(idx)" v-if="filter.length > 1">
                                    <svg class="img-fluid mr-2" width="20" height="21" viewBox="0 0 20 21">
                                        <path fill="#DA3E2C" fill-rule="nonzero" d="M17.314 3.314C13.547-.726 7.219-.946 3.18 2.82c-4.04 3.767-4.26 10.094-.494 14.134 3.767 4.039 10.095 4.26 14.134.493 4.039-3.766 4.26-10.094.494-14.133zM3.6 16.1A8.75 8.75 0 1 1 16.399 4.166 8.75 8.75 0 0 1 3.601 16.101zm9.414-3.651l-2.132-2.286 2.286-2.13a.625.625 0 0 0-.853-.915L10.031 9.25 7.9 6.965a.625.625 0 0 0-.915.852l2.132 2.286-2.286 2.13a.625.625 0 0 0 .853.915l2.285-2.131 2.131 2.285a.625.625 0 0 0 .915-.852z"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary waves-effect waves-light" @click="reset()">Reset</button>
                        <button type="button" class="btn btn-primary waves-effect waves-light" data-dismiss="modal" @click="getList()">Filter</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Detail Dokumen -->
        <div class="modal fade text-left" id="modalDetailDokumen" tabindex="-1" role="dialog" aria-labelledby="modalDetailDokumenLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="modalDetailDokumenLabel">Detail Dokumen Amandemen</h4>
                        <button type="button" class="close" @click="closeModal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="amandemen_detail">
                        <div class="row mb-2">
                            <div class="col-md-3"><strong>Nama Kontrak:</strong></div>
                            <div class="col-md-9">{{ amandemen_detail.kontrak_judul || '-' }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3"><strong>Nomor Kontrak:</strong></div>
                            <div class="col-md-9">{{ amandemen_detail.kontrak_nomor || '-' }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3"><strong>Nama Dokumen:</strong></div>
                            <div class="col-md-9">{{ amandemen_detail.amandemen_name || '-' }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3"><strong>Tanggal:</strong></div>
                            <div class="col-md-9">{{ amandemen_detail.amandemen_date ? moment(amandemen_detail.amandemen_date).format('DD-MM-YYYY') : '-' }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3"><strong>Dokumen:</strong></div>
                            <div class="col-md-9">
                                <div v-if="!amandemen_detail.documents || !amandemen_detail.documents.length" class="text-muted">
                                    Tidak ada dokumen
                                </div>
                                <div v-else>
                                    <div v-for="(doc, docIndex) in amandemen_detail.documents" :key="docIndex" class="mb-1">
                                        <p class="mb-0">
                                            <a :href="doc.document" target="_blank" class="text-primary">
                                                <i class="feather icon-download-cloud"></i> File {{ docIndex + 1 }} [Lihat Detail]
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary waves-effect waves-light" @click="closeModal()">Tutup</button>
                    </div>
                </div>
            </div>
        </div>
	</section>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import PaginateList from '@/components/PaginateList.vue';
import moment from 'moment';

export default {
	name: 'LaporanDokumenAmdProsesIndex',
	components: {
        PaginateList,
        DatePicker
	},
	data() {
		return {
			table: {
				title: "Generate Laporan Dokumen AMD Proses",
				breadcumb: "Laporan",
                dataTable: {
                    lists: {
                        data: [],
                        current_page: 1,
                        per_page: 10,
                        total: 0,
                        last_page: 1
                    },
                    columns: [
                        'kontrak_nomor',
                        'kontrak_judul',
                        'col_amandemen_date',
                        'amandemen_name',
                        'col_documents'
                    ]
                }
            },
            detail: [],
            model: {
                status: false
            },
            currentSort: 'created_at',
            currentSortDir: 'desc',
            perPage: 10,
            amandemen_detail: null,
            filterby: {
                date_start: '',
                date_end: '',
                search: ''
            },
            filter: [
                {
                    'by': '-'
                }
            ],
            filterOption: 
            [
                {
                    'name': '-',
                    'by': '-'
                },
                {
                    'name': 'Tanggal Awal',
                    'by': 'date_start'
                },
                {
                    'name': 'Tanggal Akhir',
                    'by': 'date_end'
                },
                {
                    'name': 'Pencarian',
                    'by': 'search'
                }
            ]
		}
	},
    mounted() {
        let _ = this
        _.getList()
        _.$root.$on("paginate", (data) => {
            _.getList(data)
        });
    },
    methods: {
        moment,
        getList(page = 1) {
            let _ = this
            _.axios.get('/v3/kontrak/amandemen-dokumen' + '?per_page=' + _.perPage + '&page=' + page + '&orderby=' + _.currentSort + '&sort=' + _.currentSortDir.toUpperCase()
                    + '&date_start=' + _.filterby.date_start
                    + '&date_end=' + _.filterby.date_end
                    + '&search=' + _.filterby.search
                )
                .then(resp=>{
                    // API response structure: {status: true, data: {pagination_object}}
                    const paginationData = resp.data.data
                    _.table.dataTable.lists = {
                        data: paginationData.data,                    // Array of items
                        current_page: paginationData.current_page,
                        per_page: paginationData.per_page,
                        total: paginationData.total,
                        last_page: paginationData.last_page,
                        first_page_url: paginationData.first_page_url,
                        last_page_url: paginationData.last_page_url,
                        next_page_url: paginationData.next_page_url,
                        prev_page_url: paginationData.prev_page_url,
                        from: paginationData.from,
                        to: paginationData.to,
                        path: paginationData.path
                    }
                })
                .catch(err=>{
                    console.error('API Error:', err.response)
                    // Set empty data on error
                    _.table.dataTable.lists = {
                        data: [],
                        current_page: 1,
                        per_page: _.perPage,
                        total: 0,
                        last_page: 1
                    }
                })
        },
        sortBy(x) {
            if (x === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSortDir = 'asc'
            }
            this.currentSort = x;
            this.getList()
        },
        addFilter(){
            let _ = this
            _.filter.push({
                name	: '-',
                by      : '-'
			})
        },
        deleteFilter(x) {
            let _ = this
            switch (_.filter[x].by) {
                case 'date_start':
                    _.filterby.date_start = ''
                    break;

                case 'date_end':
                    _.filterby.date_end = ''
                    break;

                case 'search':
                    _.filterby.search = ''
                    break;
            
                default:
                    break;
            }            
            _.filter.splice(x, 1);            
        },
        cetak() {
			let _ = this
            _.axios.get('/v3/kontrak/amandemen-dokumen/export' + '?orderby=' + _.currentSort + '&sort=' + _.currentSortDir.toUpperCase()
                + '&date_start=' + _.filterby.date_start
                + '&date_end=' + _.filterby.date_end
                + '&search=' + _.filterby.search
                ,{responseType: 'arraybuffer'})
                .then(resp => {
                    let blob = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'LaporanDokumenAmdProses_' + _.filterby.date_start + '-' + _.filterby.date_end + '.xlsx'
                    link.click()
                })
                .catch(err => {
                    console.log(err.response)
                })
		},
        openFileAmendment() {
            let _ = this
            if (_.amandemen_detail) {
                // Tampilkan modal detail dokumen menggunakan Bootstrap modal
                const modalElement = document.getElementById('modalDetailDokumen')
                if (modalElement) {
                    // Trigger modal using Bootstrap's data attributes atau manual
                    modalElement.style.display = 'block'
                    modalElement.classList.add('show')
                    document.body.classList.add('modal-open')
                    
                    // Tambah backdrop
                    if (!document.querySelector('.modal-backdrop')) {
                        const backdrop = document.createElement('div')
                        backdrop.className = 'modal-backdrop fade show'
                        document.body.appendChild(backdrop)
                    }
                }
            }
        },
        closeModal() {
            const modalElement = document.getElementById('modalDetailDokumen')
            if (modalElement) {
                // Hide modal
                modalElement.style.display = 'none'
                modalElement.classList.remove('show')
                document.body.classList.remove('modal-open')
                
                // Remove backdrop
                const backdrop = document.querySelector('.modal-backdrop')
                if (backdrop) {
                    backdrop.remove()
                }
            }
        },
        reset() {
            let _ = this 
            
            _.filterby.date_start = ''
            _.filterby.date_end = ''
            _.filterby.search = ''
            _.filter = [
                {
                    'by': '-'
                }
            ]
        }
    }
}
</script>

<style>
@import '~vue2-datepicker/index.css';

.text-primary {
    color: #007bff !important;
}
</style>